import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { alertsState } from './alertState';
import { AlertsState } from '../types';

export const alertsSlice = createSlice({
  name: 'logEdits',
  initialState: alertsState,
  reducers: {
    setAlert(state, action: PayloadAction<AlertsState['alert']>) {
      state.alert = action.payload;
    },
    setAlerts(state, action: PayloadAction<AlertsState['alerts']>) {
      state.alerts = action.payload;
    },
    setDrivers(
      state,
      action: PayloadAction<AlertsState['formState']['drivers']>,
    ) {
      state.formState.drivers = action.payload;
    },
    setTerminals(
      state,
      action: PayloadAction<AlertsState['formState']['terminals']>,
    ) {
      state.formState.terminals = action.payload;
    },
    setRowsPerPage(state, action: PayloadAction<number>) {
      state.limit = action.payload;
    },
    setPageIndex(state, action: PayloadAction<number>) {
      state.offset = action.payload;
    },
    setTotalRecordCounts(state, action: PayloadAction<number>) {
      state.totalRecordCount = action.payload;
    },
    setToggleDeleteAlertModal(state, action: PayloadAction<boolean>) {
      state.isToggleDeleteAlertModal = action.payload;
    },
    setEditModal(state, action: PayloadAction<boolean>) {
      state.editModal = action.payload;
    },
    setCreateModal(state, action: PayloadAction<boolean>) {
      state.createModal = action.payload;
    },
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: alertsActions } = alertsSlice;

/* ------- STATE SELECTORS ------- */
export const selectAlerts = (state: RootState) => state.alerts;

export default alertsSlice.reducer;
